import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Box, Button, List, Paper, Typography } from '@mui/material';
import { useContext } from 'react';
import { MFAContext } from './context';

export const MFAInstructions = () => {
  const { goToNextStep, goToPreviousStep } = useContext(MFAContext);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '3.5rem',
        width: '28rem',
        height: '100%',
      }}
    >
      <Paper
        elevation={8}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          paddingX: '1.5rem',
          paddingY: '1rem',
          gap: '32px',
          width: '100%',
          borderRadius: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
            padding: 0,
          }}
        >
          <VerifiedUserIcon sx={{ fontSize: '3rem' }} color='primary' />
          <Typography
            sx={{ fontWeight: '600', fontSize: '1.5rem', color: 'primary' }}
          >
            Protect your account with MFA
          </Typography>
        </Box>

        <Box>
          <List sx={{ padding: 0 }}>
            {[
              [
                'Download an authentication app',
                'Install Microsoft authentication app or another app that creates one-time verification codes on your mobile device.',
              ],
              [
                'Add new account',
                'Use the newly installed authentication app and click on the + icon to add a new account. Select ‘Work or school’ account if prompted. ',
              ],
              [
                'Scan the QR code',
                "Now select 'Scan a QR code'. This should open the camera on your mobile device. Click ‘Continue’ to scan the QR code.",
              ],
            ].map(([title, description], index) => {
              return (
                <Box key={`step-${index}`}>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: '1rem',
                        fontWeight: 'medium',
                        color: 'primary.main',
                      }}
                    >
                      {index + 1}. {title}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: '0.875rem',
                      fontWeight: 'regular',
                      paddingLeft: '18px',
                    }}
                  >
                    {description}
                  </Typography>
                </Box>
              );
            })}
          </List>
        </Box>

        <Button
          variant='contained'
          type='submit'
          color='secondary'
          sx={{ color: 'white', padding: '0.5rem', fontWeight: '500' }}
          onClick={goToNextStep}
          fullWidth
        >
          CONTINUE
        </Button>
        <Button
          variant='text'
          sx={{ padding: '0.5rem', fontWeight: '500' }}
          onClick={goToPreviousStep}
          fullWidth
        >
          SELECT OTHER AUTHENTICATION METHOD
        </Button>
      </Paper>
    </Box>
  );
};
